import { useMemo, useRef } from 'react';

//* HOC's
import { withUIContext } from 'context';

//* Config
import { config } from 'helpers';

//* Components
import Text from 'components/common/Text';
import Container from 'components/common/Container';
import EventItem from 'components/pages/events/EventItem';
import Button from 'components/common/Button';
import Animate from 'components/common/Animate';

//* Style
import UpcomingEventsStyle from './style';

const UpcomingEvents = ({ title, events, winWidth }) => {
	//! Refs
	const eventsArr = useRef([]);

	//! Store event items options
	const storeEventItems = useMemo(() => {
		let mutatedEventsArr = [];

		if (winWidth >= 1024 && winWidth < 1280) {
			mutatedEventsArr = events.slice(0, 3);
		} else if (winWidth < 1024 && winWidth >= 768) {
			mutatedEventsArr = events.slice(0, 2);
		} else {
			mutatedEventsArr = events.slice(0, 4);
		}

		return mutatedEventsArr.map((event, k) => {
			return (
				<EventItem
					className='upcoming-events-item col-3 col-dl-3 col-dm-3 col-ds-3 col-dxs-3 col-t-4 col-ts-6 col-m-12'
					key={event.id}
					data={event}
					ref={(ref) => (eventsArr.current[k] = ref)}
					index={k}
				/>
			);
		});
	}, [events, winWidth]);

	const animation = useMemo(
		() => (
			<Animate
				dependency={events}
				startX={'500%'}
				params={{ rightToLeft: [eventsArr] }}
			/>
		),
		[storeEventItems]
	);

	return (
		<UpcomingEventsStyle>
			{animation}
			<Container section>
				<Text
					className={'h3 upcoming-events-title font-ping-bolder'}
					text={title || 'upComingEventsAndFestivals'}
				/>

				<Container
					className='upcoming-events-cont'
					full
					row>
					{storeEventItems}
				</Container>

				{events.length > 4 && (
					<Button
						className={'discover-all-events-button'}
						type={'icon-aside'}
						text={'discoverAllEvents'}
						background={'ColorBigStone'}
						color={'ColorWhite'}
						hoverBackground={'ColorApricot'}
						hoverColor={'ColorBigStone'}
						url={config.routes.events.path}
					/>
				)}
			</Container>
		</UpcomingEventsStyle>
	);
};
export default withUIContext(UpcomingEvents, ['winWidth']);
